module.exports = {"430321100":"易俗河镇","430321102":"谭家山镇","430321103":"中路铺镇","430321104":"茶恩寺镇","430321105":"河口镇","430321106":"射埠镇","430321107":"花石镇","430321108":"青山桥镇","430321109":"石鼓镇","430321111":"云湖桥镇","430321112":"石潭镇","430321113":"杨嘉桥镇","430321114":"乌石镇","430321115":"白石镇","430321202":"分水乡","430321203":"排头乡","430321205":"锦石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430321.json
// module id = 1672
// module chunks = 0